import React from 'react';
import { Link } from 'react-router-dom';

const JobsPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <section className="rounded-2xl p-8 sm:p-12 text-white bg-gradient-to-br from-teal-600 via-emerald-600 to-green-600 shadow-xl">
          <h1 className="text-3xl sm:text-5xl font-extrabold">Join the LGC Jobs Program</h1>
          <p className="mt-4 text-lg text-emerald-50">
            Explore part-time and flexible opportunities to learn, contribute, and earn.
          </p>
          <ul className="mt-6 space-y-2 text-base">
            <li>- Part-time roles</li>
            <li>- Flexible schedules</li>
            <li>- Extra income opportunities</li>
          </ul>
          <div className="mt-8">
            <Link
              to="/contact"
              className="inline-flex items-center rounded-md bg-white px-5 py-3 text-sm font-semibold text-slate-900 hover:bg-slate-100"
            >
              Apply / Enquire
            </Link>
          </div>
        </section>
      </main>
    </div>
  );
};

export default JobsPage;
